module.exports = __webpack_public_path__ + "img/americano.c62cb2aa.jpg";